import axiosInstance, { ApiKeys, getApiUrl } from '@cp/src/utils/ApiHelper';
import React, { useEffect } from 'react';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import Lottie from 'react-lottie';

import useLottieAnimation from '@cp/src/hooks/useLottieAnimation';
import NaviIconWithText from '@cp/src/assets/icons/NaviIconWithText';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';

interface AppData {
  downloadPreSignedUrl: string;
  appVersion: string;
  appType: string;
  buildNumber: number;
}

const DownloadForCallingAgent = () => {
  const dancingRobot = useLottieAnimation(
    () => import('../../assets/json/dancingRobot.json'),
    'dancingRobot'
  );
  const [appData, setAppData] = React.useState<AppData>();

  const anchorTag = React.useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    const url = getApiUrl(ApiKeys.DOWNLOAD_FIELD_AGENT_APP, { appType: 'callingAgents' });
    axiosInstance
      .get(url)
      .then(response => {
        setAppData(response.data);
      })
      .catch(error => {});
  }, []);

  const handleDownload = () => {
    // Replace 'path_to_your_file' with the actual file URL
    if (!appData) return;

    const fileUrl = appData?.downloadPreSignedUrl;
    anchorTag.current?.setAttribute('href', fileUrl);
    anchorTag.current?.setAttribute('download', `calling_agent_app_${appData?.appVersion}.apk`);

    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_FIELD_AGENT_COSMOS_DOWNLOAD_BUTTON_CLICKED, {
      appVersion: appData?.appVersion,
      buildNumber: appData?.buildNumber
    });
    // Trigger click event on the anchor element
    anchorTag.current?.click();
  };

  return (
    <div>
      <div className="p-4 flex justify-center shadow-lg">
        <NaviIconWithText />
      </div>
      <div className={'flex items-center justify-center p-4'}>
        <div className="isolate  w-96 p-4 rounded-xl bg-white/20 shadow-lg ring-1 ring-black/5 shadow-lg flex justify-around">
          <div>
            <Typography variant="h1">Cosmos App</Typography>

            <Typography variant="h3" className="my-2">
              App version : {appData?.appVersion}
            </Typography>

            <Typography variant="h3">Build Number : {appData?.buildNumber}</Typography>

            <Button onClick={handleDownload} className="my-3" variant="primary">
              Download Application
            </Button>

            <a ref={anchorTag} style={{ display: 'none' }} />
          </div>

          {dancingRobot && (
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: dancingRobot,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice'
                }
              }}
              height={150}
              width={150}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadForCallingAgent;
